import { Button, message } from "antd";
import { FC, useMemo, useState } from "react";
import { useRequest } from "ahooks";

import styles from "../../index.less";

import InfoIcon from "../../../../../../assets/svg/info.svg";

import {
  OrderInfo,
  PayType,
  requestPayService,
} from "../../../../../../service";
import { ResponseCode } from "../../../../../../constants";
import ScanToAddAssistantModal from "../../../../../../components/ScanToAddAssistantModal";

interface PayWithBankTransferProps {
  payAmount?: number;
  orderInfo?: OrderInfo;
  onPayWithBankTransferConfirm: () => void;
}

const PayWithBankTransfer: FC<PayWithBankTransferProps> = ({
  payAmount,
  orderInfo,
  onPayWithBankTransferConfirm,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  useRequest(async () => {
    const rsp = await requestPayService({
      orderId: orderInfo?.orderId || "",
      payType: PayType.OFFLINE,
    });

    if (rsp.code !== ResponseCode.Success) {
      message.error(rsp.msg);
      return;
    }
  });

  const handleCopyBankTransferInformation = () => {
    const copyText = BankTransferInformation.map(
      (i) => `${i.label}：${i.value}`
    ).join("\n");

    if (window.navigator.clipboard) {
      window.navigator.clipboard.writeText(copyText);
      message.info("复制转账信息成功");
    }
  };

  const BankTransferInformation: { label: string; value: string }[] = useMemo(
    () => [
      {
        label: "订单号码",
        value: orderInfo?.orderId || "",
      },
      {
        label: "公司名称",
        value: "广州十二速率智能科技有限公司",
      },
      {
        label: "开户银行",
        value: "招商银行广州琶洲电商园支行",
      },
      {
        label: "银行账号",
        value: "120928963010001",
      },
    ],
    [orderInfo?.orderId]
  );

  return (
    <>
      <div className={styles["with-bank-transfer"]}>
        <div className={styles.tip}>
          <img src={InfoIcon} alt="info" />
          <div className={styles["tip-content"]}>
            请您将款项通过银行转账至以下帐户，并在转账过程中务必注明订单号
          </div>
        </div>
        <div className={styles["transfer-information"]}>
          <div className={styles.item}>
            <div className={styles.label}>转账金额：</div>
            <div>{payAmount ? `¥${payAmount}` : "--"}</div>
          </div>
          {BankTransferInformation.map((item) => (
            <div key={item.label} className={styles.item}>
              <div className={styles.label}>{item.label}：</div>
              <div>{item.value}</div>
            </div>
          ))}
        </div>

        <div className={styles["transfer-btn-group"]}>
          <Button type="primary" onClick={onPayWithBankTransferConfirm}>
            我已转账
          </Button>
          <Button onClick={handleCopyBankTransferInformation}>
            复制转账信息
          </Button>
        </div>

        <div className={styles.hr}></div>
        <div className={styles.tip1}>
          转账成功后，财务部门将在1个工作日内完成审批流程，审批通过将立即为您开通服务
        </div>
        <div className={styles.tip2}>
          如遇任何问题，请随时
          <div
            className={styles.highlight}
            style={{
              cursor: "pointer",
            }}
            onClick={() => setOpen(true)}
          >
            联系客服
          </div>
        </div>
      </div>

      <ScanToAddAssistantModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default PayWithBankTransfer;
